import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    name: $props.name,
    class: _normalizeClass($props.disabled ? 'revico-community-talk-label revico-community-talk-disabled' : 'revico-community-talk-label')
  }, _toDisplayString($props.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
}